import React from 'react'
import ClientSuspense from '@components/ClientSuspense'
import LoyaltyProgramOld from '@page-components/Checkout/CheckoutV2/LoyaltyProgram'
import SectionSkeleton from '@page-components/CheckoutV3/components/SectionSkeleton'
import useSections from '@page-components/CheckoutV3/hooks/useSections'

import usePreferencesForLoyalties from './hooks/usePreferencesForLoyalties'
import useWebsiteForLoyalties from './hooks/useWebsiteForLoyalties'

function LoyaltyProgramInner() {
  const website = useWebsiteForLoyalties()
  const {preferences} = usePreferencesForLoyalties()

  return (
    <div className="mt-4 sm:mt-0 w-full max-w-[1024px] text-black">
      <LoyaltyProgramOld website={website} preferences={preferences} loading={false} />
    </div>
  )
}

function LoyaltyProgram() {
  const sections = useSections()

  if (!sections.includes('loyaltyProgram')) return null

  // We avoid running queries if the section is not enabled
  return <LoyaltyProgramInner />
}

export default function LoyaltyProgramWrapper() {
  return (
    <ClientSuspense fallback={<SectionSkeleton transparentOnDesktop />}>
      <LoyaltyProgram />
    </ClientSuspense>
  )
}
